export default {
  // quality_sinCode: (state) => {
  //   return state.process?.sinCode || router?.currentRoute.query.sinCode;
  // },
  // quality_tenderCode: (state) => {
  //   return state.process?.tenderCode || router?.currentRoute.query.tenderCode;
  // },
}; 